import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withHashLocation } from '@angular/router';

import { provideClientHydration } from '@angular/platform-browser';
import { AppRoutes } from './app.routing';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptors } from '@angular/common/http';
import { LoginComponent } from 'src/app/pages/login/login.component';
// import { HttpInterceptorProviders, HttpRequestInterceptor } from './_helpers/http.interceptor';
import {  httpRequestInterceptor, } from 'src/app/_helpers/http.interceptor';
import { DatePipe, HashLocationStrategy, LocationStrategy } from '@angular/common';
import { AlertService } from './_services/alert.service';
import { AuthGuard } from './_helpers/auth.guard';

export const appConfig: ApplicationConfig = {
  providers: [AuthGuard, provideZoneChangeDetection({ eventCoalescing: true }),  provideRouter(AppRoutes, withHashLocation()), provideClientHydration(),   
    provideHttpClient(
      withInterceptors([httpRequestInterceptor])
    )
  ]

  // providers: [
  //   {
  //     provide: HTTP_INTERCEPTORS,
  //     useClass: HttpRequestInterceptor,
  //     multi: true
  //   }
  // ]

//   providers: [
//         LoginComponent, HttpInterceptorProviders,
//         {
//             provide: [HTTP_INTERCEPTORS], multi: true,
//             useValue: {
//             }
//         },
//         { provide: LocationStrategy, useClass: HashLocationStrategy },
//         AlertService, DatePipe
//     ],
};
